import { useState } from "react";
import { useTransactions } from "../../services/useTransactions";
import TransactionRow from "./TransactionRow";
import Filters from "./Filters";

export default function ReconcilePage() {
  const [filters, setFilters] = useState({ start: "", end: "", matched: "" });
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useTransactions({
    ...filters,
    page,
  });

  if (isLoading) return <p>Carregando...</p>;
  if (error) return <p className="text-red-500">{error.message}</p>;

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Conciliação</h1>
      <Filters values={filters} onChange={setFilters} />
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-black p-2">Data</th>
            <th className="border border-black p-2">Descrição</th>
            <th className="border border-black p-2">Valor</th>
            <th className="border border-black p-2">Ação</th>
          </tr>
        </thead>
        <tbody>
          {data!.results.map((tx) => (
            <TransactionRow key={tx.id} tx={tx} />
          ))}
        </tbody>
      </table>
      <div className="flex justify-end gap-2 mt-4">
        <button
          disabled={!data!.previous}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          className="px-2 border rounded"
        >
          Anterior
        </button>
        <button
          disabled={!data!.next}
          onClick={() => setPage((p) => p + 1)}
          className="px-2 border rounded"
        >
          Próxima
        </button>
      </div>
    </div>
  );
}
